import styled from "@emotion/styled";
import { Box, Paper } from "@mui/material";

export const SecaoPaper = styled(Paper)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 1.25rem 1.5rem 1.5rem;
    border: 1px solid ${props => props.theme.palette.divider};
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: ${props => props.theme.shadows[2]};
    }
`

export const CabecalhoSecao = styled(Box)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    @media(max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
    }
`

export const TextosCabecalho = styled(Box)`
    display: flex;
    flex-direction: column;
    min-width: 0;
`
